var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWoman2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 434 434",
    style: {
      enableBackground: "new 0 0 434 434"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M293.505,318h-153.01V183c0-48.12,33.194-87.26,74.53-88.47c0.657-0.02,1.314-0.03,1.971-0.03h0.009 c42.244,0,76.501,39.62,76.501,88.5v135H293.505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M266.355,256.97c0.19,0.05,0.39,0.09,0.58,0.14c10.46,2.53,20.19,6.93,28.83,12.81 c23.39,15.92,38.75,42.77,38.75,73.19V428h-47.04h-140.96h-47.03v-84.89c0-30.42,15.35-57.27,38.74-73.19 c8.64-5.88,18.37-10.28,28.83-12.81c0.19-0.05,0.39-0.09,0.58-0.14"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M146.515,304v124h-47.03v-84.89c0-30.42,15.35-57.27,38.74-73.19 C143.525,280.12,146.515,291.71,146.515,304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M334.515,343.11V428h-47.04V304c0-12.29,2.99-23.88,8.29-34.08 C319.155,285.84,334.515,312.69,334.515,343.11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M342.5,428h-12v-78.69c0-25.831-11.669-50.163-32.857-68.515 C276.213,262.226,247.663,252,217.25,252C154.804,252,104,295.653,104,349.31V428H92v-78.69C92,289.036,148.187,240,217.25,240 c33.299,0,64.641,11.267,88.25,31.726c23.859,20.665,37,48.219,37,77.584V428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M293.475,428h-12V304c0-12.816,3.101-25.558,8.966-36.846l10.648,5.533 c-5.053,9.724-7.614,20.259-7.614,31.313V428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M314.515,414c-3.313,0-6-2.687-6-6v-73c0-3.313,2.687-6,6-6s6,2.687,6,6v73 C320.515,411.313,317.828,414,314.515,414z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.44,
      fill: "#333333",
      enableBackground: "new"
    },
    d: "M143.165,281.92c-15.21,15.89-24.56,37.45-24.56,61.19V426 h-19.12v-82.89c0-30.42,15.35-57.27,38.74-73.19C140.205,273.74,141.865,277.75,143.165,281.92z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M152.515,428h-12V304c0-11.054-2.562-21.59-7.614-31.313l10.648-5.533 c5.865,11.289,8.966,24.03,8.966,36.846V428z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M257.09,248v24c0,14.71-11.93,26.64-26.64,26.64h-30.72c-14.71,0-26.64-11.93-26.64-26.64v-24 c12.5,6.75,26.8,10.58,41.99,10.58C230.29,258.58,244.59,254.75,257.09,248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M230.45,304.64h-30.721c-17.998,0-32.64-14.642-32.64-32.64v-24h12v24 c0,11.381,9.259,20.64,20.64,20.64h30.721c11.381,0,20.64-9.259,20.64-20.64v-24h12v24 C263.09,289.998,248.448,304.64,230.45,304.64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.44,
      fill: "#333333",
      enableBackground: "new"
    },
    d: "M260.91,246c0-7-2.45,16.06-3.82,18.18 c-6.42,10.03-14.81,18.67-24.62,25.39c-0.19,0.14-0.39,0.27-0.58,0.4c-14.1,9.49-13.88,8.67-32.16,8.67 c-5.24,0-23.31-13.1-26.64-15.64v-35c11.87,5.92,27.245,8,41.415,8C232.365,256,247.01,255.09,260.91,246z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M348.5,434H85.729c-3.313,0-6-2.687-6-6s2.687-6,6-6H348.5c3.313,0,6,2.687,6,6 S351.813,434,348.5,434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M380.5,434h-11c-3.313,0-6-2.687-6-6s2.687-6,6-6h11c3.313,0,6,2.687,6,6S383.813,434,380.5,434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M64.5,434h-11c-3.313,0-6-2.687-6-6s2.687-6,6-6h11c3.313,0,6,2.687,6,6S67.813,434,64.5,434z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8B974"
    },
    d: "M305.505,94.5v74c0,20.68-7.09,39.7-18.99,54.77c-5.55,7.04-12.15,13.22-19.57,18.3 c-0.19,0.14-0.4,0.27-0.58,0.4c-0.32,0.22-0.64,0.43-0.97,0.64c-13.9,9.1-30.53,14.39-48.4,14.39c-18.27,0-35.25-5.54-49.35-15.03 c-0.2-0.13-0.4-0.26-0.58-0.4c-13.42-9.19-24.18-21.97-30.9-36.97c-4.93-11.02-7.67-23.24-7.67-36.1v-74 c0-15.22,3.84-29.54,10.61-42.05C154.075,24.79,183.345,6,216.995,6h0.01C265.875,6,305.505,45.62,305.505,94.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M216.995,263c-18.873,0-37.097-5.551-52.7-16.052c-0.232-0.151-0.485-0.322-0.729-0.501 c-6.941-4.77-13.211-10.434-18.638-16.837l9.154-7.758c4.764,5.62,10.271,10.589,16.373,14.77c0.095,0.065,0.188,0.132,0.278,0.203 l0.167,0.107c0.022,0.014,0.072,0.047,0.094,0.062C184.61,246.156,200.518,251,216.995,251c16.464,0,32.354-4.828,45.955-13.964 c0.111-0.078,0.228-0.157,0.346-0.236l0.116-0.079c0.053-0.038,0.09-0.064,0.144-0.101c6.086-4.167,11.589-9.127,16.354-14.742 l9.148,7.765c-5.44,6.411-11.719,12.074-18.661,16.836c-0.138,0.098-0.279,0.194-0.419,0.288l-0.106,0.072 c-0.057,0.042-0.099,0.07-0.157,0.109C254.111,257.449,235.881,263,216.995,263z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7774B"
    },
    d: "M217,216.01c-4.869,0-9.738-0.513-14.572-1.538c-3.242-0.688-5.313-3.873-4.625-7.114 c0.687-3.241,3.874-5.313,7.113-4.625c8.02,1.7,16.148,1.7,24.168,0c3.239-0.685,6.427,1.383,7.113,4.625 c0.688,3.242-1.383,6.427-4.625,7.114C226.738,215.497,221.869,216.01,217,216.01z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.44
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M217.505,229h-1.01c-2.209,0-4-1.791-4-4s1.791-4,4-4h1.01c2.209,0,4,1.791,4,4 S219.714,229,217.505,229z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M272.473,140.414c-0.452,0-0.912-0.052-1.372-0.159c-7.916-1.853-16.285-1.853-24.201,0 c-3.232,0.757-6.455-1.25-7.209-4.476c-0.755-3.227,1.248-6.454,4.475-7.209c9.705-2.27,19.963-2.271,29.67,0 c3.227,0.755,5.229,3.982,4.475,7.209C277.663,138.546,275.197,140.414,272.473,140.414z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#333333"
    },
    cx: 182.66,
    cy: 157.116,
    r: 8.009
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M167.33,164.208c-1.533,0-3.065-0.583-4.236-1.751c-2.347-2.34-2.353-6.139-0.013-8.485 c6.153-6.169,15.544-7.745,23.376-3.919c2.977,1.455,4.211,5.048,2.756,8.025c-1.454,2.977-5.044,4.213-8.025,2.756 c-3.218-1.573-7.08-0.925-9.608,1.611C170.406,163.62,168.868,164.208,167.33,164.208z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#333333"
    },
    cx: 251.34,
    cy: 157.116,
    r: 8.009
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M266.669,164.208c-1.539,0-3.077-0.588-4.249-1.764c-2.528-2.537-6.39-3.183-9.607-1.611 c-2.978,1.457-6.57,0.221-8.025-2.756c-1.455-2.977-0.222-6.57,2.756-8.025c7.83-3.827,17.224-2.251,23.375,3.919 c2.34,2.347,2.334,6.146-0.013,8.485C269.734,163.624,268.201,164.208,266.669,164.208z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M210.057,189c-3.313,0-6-2.687-6-6v-32.927c0-2.692-1.515-5.195-3.858-6.375 c-7.192-3.621-19.527-7.153-37.439-3.412c-3.245,0.674-6.422-1.403-7.1-4.647s1.403-6.422,4.646-7.1 c21.303-4.446,36.388-0.04,45.289,4.44c6.453,3.25,10.462,9.799,10.462,17.094V183C216.057,186.313,213.37,189,210.057,189z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.44,
      fill: "#333333",
      enableBackground: "new"
    },
    d: "M198.015,30h-0.01c-10.287,0-20.154,1.77-29.336,4.996 c1.279-2.593,2.717-5.134,4.337-7.6l10.384-15.807c0-1.942-24.783-3.346-41.043,38.112c-1.101,0.892-2.185,1.805-3.242,2.749 c-6.77,12.51-10.61,26.83-10.61,42.05v74c0,1.861,0.064,3.708,0.177,5.541c0.006,0.093,0.012,0.185,0.019,0.277 c0.053,0.823,0.118,1.643,0.194,2.459c0.009,0.098,0.018,0.197,0.028,0.295c0.083,0.862,0.177,1.72,0.284,2.574 c0.003,0.026,0.006,0.052,0.009,0.078c1.107,8.756,3.487,17.115,6.959,24.876c0.003-0.009,0.006-0.018,0.008-0.028 c6.708,15.006,17.463,27.806,30.887,36.998c0.19,0.14,0.39,0.27,0.58,0.4C181.74,251.46,198.72,257,217,257 c5.29,0,10.47-0.46,15.5-1.35c-12.36-2.19-23.84-6.94-33.86-13.68c-0.19-0.13-0.39-0.26-0.58-0.4 c-23.28-15.94-38.56-42.72-38.56-73.07v-7.045c1.576-1.719,3.165-3.338,4.755-4.834c16.88-15.87,33.75-19.62,33.75-19.62 s64.51,14.34,67.39,105.61c0.33-0.21,0.65-0.42,0.97-0.64c0.18-0.13,0.39-0.26,0.58-0.4c7.42-5.08,14.02-11.26,19.57-18.3V118.5 C286.515,69.62,246.885,30,198.015,30z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M305.505,137v31.9l-0.01,133.21L284.485,323V201c0.005-48.979-17.202-77.051-34.241-92.841 c-18.724-17.352-47.762-17.355-66.493-0.011c-0.169,0.156-0.338,0.314-0.506,0.472c-16.87,15.88-33.74,43.88-33.74,92.38v122 l-21.01-20.89V168.5V137V94.5c0-48.88,39.63-88.5,88.5-88.5h0.01c48.877,0,88.5,39.623,88.5,88.5V137z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.44
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M156.994,168.5V137V94.5c0-44.029,32.157-80.539,74.255-87.353C226.612,6.396,221.855,6,217.005,6 h-0.01c-48.87,0-88.5,39.62-88.5,88.5V137v31.5v133.61l21.01,20.89v-98c0-20.089,2.9-36.651,7.489-50.301V168.5z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M149.506,329c-1.556,0-3.085-0.605-4.231-1.745c-14.477-14.394-22.779-34.358-22.779-54.772V94.5 c0-52.107,42.393-94.5,94.5-94.5c52.117,0,94.51,42.393,94.51,94.5l-0.008,177.986c-0.001,20.412-8.304,40.374-22.779,54.767 c-0.276,0.274-0.578,0.521-0.902,0.737c-1.839,1.228-4.21,1.343-6.161,0.299c-1.95-1.044-3.17-3.076-3.17-5.289V201 c0.005-38.262-11.172-68.845-32.322-88.444c-16.351-15.152-41.973-15.155-58.331-0.009l-0.478,0.445 c-20.834,19.611-31.849,50.045-31.849,88.007v122c0,2.424-1.458,4.609-3.696,5.54C151.064,328.85,150.282,329,149.506,329z  M216.992,89.21c13.434,0,26.861,4.847,37.326,14.544C270.82,119.046,290.49,148.33,290.484,201v104.513 c5.824-9.953,9.012-21.404,9.013-33.028L299.505,94.5c0-45.491-37.01-82.5-82.5-82.5c-45.5,0-82.51,37.009-82.51,82.5v177.982 c0,11.624,3.187,23.074,9.01,33.028V201c0-28.837,6.181-69.031,35.628-96.749l0.547-0.51 C190.142,94.054,203.569,89.21,216.992,89.21z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M287.503,120.999c-0.391,0-0.78-0.04-1.17-0.12c-0.38-0.07-0.761-0.19-1.12-0.34 c-0.37-0.15-0.71-0.33-1.04-0.55c-0.33-0.22-0.64-0.47-0.91-0.75c-0.28-0.27-0.53-0.58-0.75-0.91c-0.21-0.32-0.4-0.67-0.55-1.03 c-0.15-0.37-0.26-0.74-0.34-1.13c-0.08-0.38-0.12-0.78-0.12-1.17c0-1.58,0.64-3.12,1.76-4.24c0.271-0.28,0.58-0.53,0.91-0.75 c0.33-0.21,0.67-0.4,1.04-0.55c0.359-0.15,0.74-0.26,1.12-0.34c0.77-0.16,1.569-0.16,2.34,0c0.39,0.08,0.76,0.19,1.13,0.34 c0.36,0.15,0.71,0.34,1.03,0.55c0.33,0.22,0.64,0.47,0.91,0.75c1.119,1.11,1.76,2.66,1.76,4.24c0,0.39-0.04,0.79-0.12,1.17 c-0.07,0.39-0.19,0.76-0.34,1.13c-0.15,0.36-0.33,0.71-0.55,1.03c-0.221,0.33-0.471,0.64-0.75,0.91 c-0.271,0.28-0.58,0.53-0.91,0.75c-0.32,0.22-0.67,0.4-1.03,0.55c-0.37,0.15-0.74,0.27-1.13,0.34 C288.293,120.959,287.893,120.999,287.503,120.999z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M287.505,100.5c-3.313,0-6-2.687-6-6c0-28.579-19.188-54.07-46.661-61.99 c-3.184-0.918-5.021-4.243-4.104-7.427c0.918-3.185,4.244-5.021,7.428-4.103c32.581,9.392,55.337,39.625,55.337,73.521 C293.505,97.813,290.818,100.5,287.505,100.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoman2);
export default __webpack_public_path__ + "static/media/woman2.4416c6da460d45c08bf688161581a6df.svg";
export { ForwardRef as ReactComponent };